const pad = (v: string) => v.padStart(4, '0');
// remove -alpha or -beta suffix, pad each version part to 4 digits (1.1.232-alpha => 0001.0001.0232)
const prep = (v: string) => v.replace(/-\w*$/, '').split('.').map(pad).join('.');
export const compareVersions = (a = '0', b = '0') => prep(a).localeCompare(prep(b));
